import DOMPurify from "dompurify";
import { marked } from "marked";

interface RichContentProps {
  content: string;
  className?: string;
  format?: "html" | "markdown";
}

const RichContent = ({ content, className = "", format = "html" }: RichContentProps) => {
  const rendered = format === "markdown" ? marked.parse(content, { async: false, gfm: true }) : content;
  const isHtml = format === "markdown" || /<[a-z][\s\S]*>/i.test(content);

  if (!isHtml) {
    return (
      <div className={className}>
        {content.split("\n").map((paragraph, i) =>
          paragraph.trim() ? <p key={i} className="text-muted-foreground leading-relaxed mb-4">{paragraph}</p> : null
        )}
      </div>
    );
  }

  const clean = DOMPurify.sanitize(rendered, format === "markdown" ? { FORBID_TAGS: ["iframe", "script", "style", "form"], FORBID_ATTR: ["style"] } : {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "src", "width", "height"],
  });

  return (
    <div
      className={`prose prose-lg prose-neutral max-w-none prose-headings:text-foreground prose-p:text-foreground/85 prose-li:text-foreground/85 prose-strong:text-foreground prose-a:text-primary prose-blockquote:text-foreground/80 prose-code:text-foreground ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};

export default RichContent;
